import { useCallback } from "react";

import Grid from "@mui/material/Grid";
import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { LoadingOrValue } from "@covertree/ui";

import {
  CommissionablePartner as CommissionablePartnerGraphQL,
  PolicyWithAgencyDataFragment,
} from "@covertree/agent-portal-graphql";
import { PolicyDetailsContentProps } from "../../../types";

interface CommissionablePartnerProps extends PolicyDetailsContentProps {
  policy: PolicyWithAgencyDataFragment;
}
export function CommissionablePartner({
  policy,
  loading,
}: CommissionablePartnerProps) {
  const getPropertiesPerItem = useCallback(
    (partner: CommissionablePartnerGraphQL, isFirstItem = false) => [
      {
        label: "Commissionable partner name",
        value: isFirstItem ? (
          <LoadingOrValue
            loading={!policy && loading}
            value={partner?.commissionablePartnerName ?? "N/A"}
            height={24}
            width={121}
          />
        ) : (
          partner?.commissionablePartnerName ?? "N/A"
        ),
        showAsTypography: true,
        gridSize: 6,
      },
      {
        label: "Commissionable partner ID",
        value: isFirstItem ? (
          <LoadingOrValue
            loading={!policy && loading}
            value={partner?.commissionablePartnerId ?? "N/A"}
            height={24}
            width={121}
          />
        ) : (
          partner?.commissionablePartnerId ?? "N/A"
        ),
        showAsTypography: true,
        gridSize: 6,
      },
    ],
    [policy?.commissionablePartners]
  );
  return (
    <Grid item xs={12}>
      <DisplayPropertiesCard
        properties={[
          ...getPropertiesPerItem(policy?.commissionablePartners[0], true),
          ...(policy?.commissionablePartners.length > 1
            ? policy?.commissionablePartners
                .slice(1)
                .map((partner) => getPropertiesPerItem(partner))
                .flat()
            : []),
        ]}
      />
    </Grid>
  );
}
